module.exports = __webpack_public_path__ + "img/plan_2.2a3bd67a.png";